/* @license
 * Copyright (c) 2026 k1pp0
 * SPDX-License-Identifier: MIT
 *
 * Icon: Lucide "download"
 * Source: https://github.com/lucide-icons/lucide
 * Copyright Lucide Contributors, ISC License
 */
import { html } from 'lit';
export default html `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
  <polyline points="7 10 12 15 17 10"/>
  <line x1="12" x2="12" y1="15" y2="3"/>
</svg>
`;
//# sourceMappingURL=capture-download-svg.js.map